module.exports = __webpack_public_path__ + "img/roboto-v20-latin-900.9c4bedee.svg";